import {FC} from 'react'
import classNames from 'classnames'
import {ChevronRightIcon} from '../SvgIcon'

interface CloseRightViewProps {
  onClick: () => void
  classes?: string
  dataCy?: string
  isBlueBackground?: boolean
}
export const CloseRightView: FC<CloseRightViewProps> = ({
  onClick,
  classes,
  dataCy = 'close-right-view-button',
  isBlueBackground = false,
}) => {
  return (
    <button
      data-cy={dataCy}
      className={classNames(
        'w-6 h-6 rounded-full flex justify-center items-center cursor-pointer',
        {
          'bg-dope-black hover:bg-gray-700': !isBlueBackground,
          'bg-dope-teal-100 hover:bg-dope-teal-300': isBlueBackground,
        },
        classes,
      )}
      onClick={onClick}
      aria-label="Close right view button"
    >
      <ChevronRightIcon strokeColor="text-gray-200" />
    </button>
  )
}
